module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.review && _vm.retailer) ? _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_c('div', {
    staticClass: "panel panel--header"
  }, [_c('h1', [_vm._v("Review | ID: " + _vm._s(_vm.review.id))])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [_c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "card__content contact-info",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "20%"
    }
  }, [_c('div', {
    staticClass: "layout header"
  }, [_c('div', {
    staticClass: "layout__item header__left",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "review-rating--numerical"
  }, [_vm._v(_vm._s(_vm.numericalRating))]), _vm._v(" "), _c('review-stars', {
    attrs: {
      "active": _vm.review.overallRating,
      "large": true
    }
  }), _vm._v(" "), (_vm.washroom) ? _c('span', {
    staticClass: "washroom-info"
  }, [_vm._v("\n                        " + _vm._s(_vm.washroom.humanId)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.washroom.name) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.washroom) ? _c('washroom-icon', {
    attrs: {
      "washroom": _vm.washroom,
      "large": true
    }
  }) : _c('washroom-icon', {
    attrs: {
      "washroom-type": _vm.review.washroomType,
      "large": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "retailer-info"
  }, [_c('h3', {
    staticClass: "retailer-info__name"
  }, [_vm._v(_vm._s(_vm.retailer.name))]), _vm._v(" "), _c('p', {
    staticClass: "retailer-info__address"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/pin.svg"
    }
  }), _vm._v(" " + _vm._s(_vm.retailer.address) + ", " + _vm._s(_vm.retailer.city) + ", " + _vm._s(_vm.retailer.postcode))])])], 1)]), _vm._v(" "), _c('splitter')], 1), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "80%"
    }
  }, [_c('div', {
    staticClass: "layout review-main",
    staticStyle: {
      "height": "100%",
      "padding-top": "3rem"
    }
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%",
      "height": "100%"
    }
  }, [_c('scroller', _vm._l((_vm.filteredIssues), function(i, index) {
    return _c('issue-badge', {
      key: index,
      attrs: {
        "issue": i
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%",
      "height": "100%"
    }
  }, [_c('scroller', [_c('div', [_c('h2', {
    staticClass: "section--heading"
  }, [_vm._v("Review breakdown")])]), _vm._v(" "), _c('div', {
    staticClass: "layout sub-rating"
  }, [_c('div', {
    staticClass: "layout__item title",
    staticStyle: {
      "width": "33.333333333%"
    }
  }, [_vm._v("\n                            Cleanliness\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "layout__item rating--icons",
    staticStyle: {
      "width": "33.333333333%"
    }
  }, [_c('review-stars', {
    attrs: {
      "active": _vm.review.cleanlinessRating
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layout__item rating--numerical text--right",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.intToDecimal(_vm.review.cleanlinessRating)) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "layout sub-rating"
  }, [_c('div', {
    staticClass: "layout__item title",
    staticStyle: {
      "width": "33.333333333%"
    }
  }, [_vm._v("\n                            Facilities\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "layout__item rating--icons",
    staticStyle: {
      "width": "33.333333333%"
    }
  }, [_c('review-stars', {
    attrs: {
      "active": _vm.review.environmentRating
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layout__item rating--numerical text--right",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.intToDecimal(_vm.review.environmentRating)) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "layout sub-rating"
  }, [_c('div', {
    staticClass: "layout__item title",
    staticStyle: {
      "width": "33.333333333%"
    }
  }, [_vm._v("\n                            Overall Experience\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "layout__item rating--icons",
    staticStyle: {
      "width": "33.333333333%"
    }
  }, [_c('review-stars', {
    attrs: {
      "active": _vm.review.facilitiesRating
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layout__item rating--numerical text--right",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.intToDecimal(_vm.review.facilitiesRating)) + "\n                          ")])]), _vm._v(" "), _c('splitter'), _vm._v(" "), _c('div', {
    staticClass: "review-body"
  }, [_c('span', {
    staticClass: "review-date"
  }, [_vm._v(_vm._s(_vm._f("date")(_vm.review.createdAt, '%d.%m.%Y')))]), _vm._v(" "), _c('review-mood', {
    attrs: {
      "mood": _vm.review.rating
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "review-comment"
  }, [_vm._v("\n                            " + _vm._s(_vm.review.comment) + "\n                          ")])], 1)], 1)], 1)])])])])])])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3baf9a7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ReviewsDetail/ReviewsDetail.vue
// module id = 541
// module chunks = 1